const Logo = ({ className = '', variant = 'light' }) => {
  const primary = variant === 'light' ? '#0B2545' : '#F6F8FA';
  const accent = variant === 'light' ? '#3E5C76' : '#8DA9C4';
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg width="36" height="36" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 32 L14 14 L20 22 L28 8 L36 32 Z" fill={primary} opacity="0.9" />
        <path d="M4 32 L14 14 L20 22 L28 8 L36 32 Z" stroke={accent} strokeWidth="1" strokeLinejoin="round" />
        <circle cx="28" cy="8" r="1.6" fill={accent} />
        <line x1="2" y1="36" x2="38" y2="36" stroke={accent} strokeWidth="1" opacity="0.5" />
      </svg>
      <div className="flex flex-col leading-none">
        <span className="font-serif text-[15px] font-semibold tracking-tight" style={{ color: primary }}>
          Northwest
        </span>
        <span className="text-[10.5px] font-medium tracking-[0.22em] uppercase" style={{ color: accent }}>
          Title Alliance
        </span>
      </div>
    </div>
  );
};

export default Logo;
